/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The configuration of the animatic for a mixing tank.
 */
export type AnimaticMixingTankConfig = {
  /**
   * A reference to a reading or setting.
   */
  levelRef?: Ref | undefined;
};

/** @internal */
export const AnimaticMixingTankConfig$inboundSchema: z.ZodType<
  AnimaticMixingTankConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  level_ref: types.optional(Ref$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "level_ref": "levelRef",
  });
});
/** @internal */
export type AnimaticMixingTankConfig$Outbound = {
  level_ref?: Ref$Outbound | undefined;
};

/** @internal */
export const AnimaticMixingTankConfig$outboundSchema: z.ZodType<
  AnimaticMixingTankConfig$Outbound,
  z.ZodTypeDef,
  AnimaticMixingTankConfig
> = z.object({
  levelRef: Ref$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    levelRef: "level_ref",
  });
});

export function animaticMixingTankConfigToJSON(
  animaticMixingTankConfig: AnimaticMixingTankConfig,
): string {
  return JSON.stringify(
    AnimaticMixingTankConfig$outboundSchema.parse(animaticMixingTankConfig),
  );
}
export function animaticMixingTankConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticMixingTankConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticMixingTankConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticMixingTankConfig' from JSON`,
  );
}
